export const pagination = {
  pageSize: 10,
  current: 1,
  total: 0,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true
}
